module.exports = "/_next/static/images/game-1-phone-attachment-bridge-d97f8053791b605facf53aee7fa0d463.jpg";